import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

/**
 * Listens for path changes and scrolls window to top.
 */
export const RouterScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	}, [pathname]);

	return null;
};
